import { useEffect } from "react";
import { Box, Typography } from "@mui/material";
import { useBreadcrumb } from "@accredo/fe-shared/contexts/BreadcrumbContext.jsx";
import SpartenTable from "../../../components/tables/SpartenTable.jsx";

export default function SparteIndexPage() {
  const { setBreadcrumbs } = useBreadcrumb();

  useEffect(() => {
    setBreadcrumbs([
      { name: "Home", path: "/home" },
      { name: "Einstellungen", path: "/admin/settings" },
      { name: "Sparten", path: "/admin/sparten" },
    ]);
  }, [setBreadcrumbs]);

  return (
    <Box>
      <Box sx={{ mb: 4 }}>
        <Typography variant="h1" gutterBottom>
          Sparten
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Übersicht aller Versicherungssparten
        </Typography>
      </Box>

      <SpartenTable />
    </Box>
  );
}
